import { LayoutDashboard, Building2, Car, Images, CalendarDays, Coffee } from "lucide-react";

export const EMPLOYEE_NAV = [
  { to: "/employee", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/employee/schedule", label: "Schedule", icon: CalendarDays },
  { to: "/employee/dealerships", label: "Dealership Tags", icon: Building2 },
  { to: "/employee/customers", label: "Customer Cars", icon: Car },
  { to: "/employee/breaks", label: "Break History", icon: Coffee },
  { to: "/employee/uploads", label: "My Uploads", icon: Images },
];
